var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1C3.24 1 1 3.24 1 6C1 8.76 3.24 11 6 11C8.76 11 11 8.76 11 6C11 3.24 8.76 1 6 1ZM6 10C3.795 10 2 8.205 2 6C2 3.795 3.795 2 6 2C8.205 2 10 3.795 10 6C10 8.205 8.205 10 6 10ZM7.94 4.145L5 7.085L4.06 6.145C3.96651 6.05151 3.83971 5.99899 3.7075 5.99899C3.57529 5.99899 3.44849 6.05151 3.355 6.145C3.26151 6.23849 3.20899 6.36529 3.20899 6.4975C3.20899 6.62971 3.26151 6.75651 3.355 6.85L4.65 8.145C4.845 8.34 5.16 8.34 5.355 8.145L8.65 4.85C8.69635 4.80374 8.73313 4.7488 8.75822 4.68831C8.78331 4.62783 8.79622 4.56298 8.79622 4.4975C8.79622 4.43202 8.78331 4.36717 8.75822 4.30669C8.73313 4.2462 8.69635 4.19126 8.65 4.145C8.455 3.95 8.135 3.95 7.94 4.145Z",
    fill: "#006644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusSuccessIcon);
export default __webpack_public_path__ + "static/media/StatusSuccessIcon.9fa06944149cbb5435615db655986efe.svg";
export { ForwardRef as ReactComponent };